export const SOCIALS = {
  facebook: 'https://www.facebook.com/FijewskiGallery',
  instagram: 'https://www.instagram.com/fijewski.gallery/',
  youtube: 'https://www.youtube.com/channel/UCwhrY2xvPTlRclrkiKgHL0g/featured',
}
